<div *ngIf="onlyIcon == false && ( !item.permissions || hasPermission(item.permissions) )">
  <div mat-subheader *ngIf="item.navCap" class="nav-caption">
    {{ item.navCap }}
  </div>
  <a mat-list-item (click)="onItemSelected(item)" [ngClass]="{
    'mat-toolbar mat-primary activeMenu': item.route
      ? router.isActive(item.route, true)
      : false,
  }" class="menu-list-item" *ngIf="!item.navCap">
    <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
    <span class="hide-menu">{{ item.displayName }}</span>
  </a>
</div>
<div *ngIf="onlyIcon == true && ( !item.permissions || hasPermission(item.permissions) )">
  <div mat-subheader *ngIf="item.navCap" class="nav-caption">
  <!--  {{ item.navCap | slice:0:1 }}-->
  </div>
  <a mat-list-item (click)="onItemSelected(item)" [ngClass]="{
      'mat-toolbar mat-primary activeMenu': item.route
        ? router.isActive(item.route, true)
        : false,
    }" class="menu-list-item" *ngIf="!item.navCap">
    <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon [matTooltip]="item.displayName" ></i-tabler>
  </a>
</div>